module.exports = __webpack_public_path__ + "static/img/slogan.f896bfe5.png";